<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="storeForm"
      :rules="storeFormRule"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <h4 class="title">General Info</h4>
      <div class="form-group">
        <el-form-item
          label="Name"
          prop="name"
        >
          <el-input
            v-model="storeForm.name"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Display Name"
          prop="displayname">
          <el-input
            v-model="storeForm.displayname"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Slug"
          prop="slug"
        >
          <el-input
            v-model="storeForm.slug"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Member ID"
          prop="member_id"
        >
          <el-input
            v-model.trim="storeForm.member_id"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Store Url"
          prop="store_url"
        >
          <el-input
            v-model.trim="storeForm.store_url"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Validation Text"
          prop="validation_text"
        >
          <el-input
            v-model.trim="storeForm.validation_text"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Genders"
          prop="genders"
        >
          <template #label>
            <label for="genders">{{ $t('table.gender') }}</label>
            <gx-tooltip>
              You can enter multiple genders by separating them with commas. For example: w,m,k.
            </gx-tooltip>
          </template>
          <el-input
            v-model.trim="storeForm.genders"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Company Location"
          prop="company_location"
        >
          <el-input
            v-model="storeForm.company_location"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Bio"
          prop="bio"
        >
          <el-input 
            v-model="storeForm.bio"
            clearable
          />
        </el-form-item>
      </div>
      
      <div class="form-group">
        <el-form-item
          label="Banner Image"
          prop="image"
        >
          <el-upload
            v-loading="isUploading"
            v-model="image"
            :file-list="imageList"
            :limit="1"
            :disabled="isUploading"
            :http-request="handleUpload"
            :before-upload="handleBeforeUpload"
            :on-exceed="handleUploaderlimitExceed"
            :on-error="uploadfailed"
            :on-success="uploadSuccessful"
            list-type="picture"
            drag
            accept=".png, .jpg"
            action="noneed"
            :data="{field_name:'image'}"
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
          </el-upload>
        </el-form-item>
      </div>

      <!-- <div class="form-group">
        <el-form-item
          label="Banner Image"
          prop="image"
        >
          <el-input
            v-model.trim="storeForm.image"
            clearable
          />
        </el-form-item>
      </div> -->

      <div class="form-group">
        <el-form-item
          label="Coupon Image"
          prop="coupon"
        >
          <el-upload
            v-loading="isUploading"
            v-model="coupon_image"
            :file-list="couponImageList"
            :limit="1"
            :disabled="isUploading"
            :http-request="handleUpload"
            :before-upload="handleBeforeUpload"
            :on-exceed="handleUploaderlimitExceed"
            :on-error="uploadfailed"
            :on-success="uploadSuccessful"
            list-type="picture"
            drag
            accept=".png, .jpg"
            action="noneed"
            :data="{field_name:'coupon_image'}"
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
          </el-upload>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Tier"
          prop="tier"
        >
          <el-select
            v-model="storeForm.tier"
            label="Tier"
          >
            <el-option
              v-for="tier in storeTiers"
              :key="`tier-${tier.value}`"
              :label="tier.label"
              :value="tier.value"
            />
          </el-select>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Official Account"
          prop="official_account"
        >
          <el-checkbox
            v-model="storeForm.official_account"
            label="official Account"
            name="officialAccount"
          >
            Yes
          </el-checkbox>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Available Platform(s)"
          prop="available_platform"
        >
          <el-checkbox-group v-model="storeForm.available_platform">
            <el-checkbox
              v-for="platform in availablePlatforms"
              :key="platform.label"
              :label="platform.label"
              name="availablePlatforms"
            >
              {{ platform.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Available Country(s)"
          prop="available_countries"
        >
          <el-checkbox-group v-model="storeForm.available_countries">
            <el-checkbox
              v-for="country in availableCountries"
              :key="country"
              :label="country"
              name="availableCountry"
            />
          </el-checkbox-group>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Subscription"
          prop="is_subscription"
        >
          <el-switch
            v-model="storeForm.is_subscription"
            inactive-color="#f56c6c"
          />
        </el-form-item>
        <el-form-item
          label="Generate Password"
          prop="is_generate_password"
        >
          <el-switch
            v-model="storeForm.is_generate_password"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>
      <div class="form-group"
        v-if="storeForm.is_subscription"
      >
        <el-form-item
          label="Plan Name"
          prop="subscription.name"
          :rules="[{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }]"
        >
          <el-input
            v-model="storeForm.subscription.name"
            clearable
            :disabled="disableSubscription"
          />
        </el-form-item>
        <el-form-item
          label="Plan Description"
          prop="subscription.description"
          :rules="[{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }]"
          >
          <el-input
            v-model="storeForm.subscription.description"
            clearable
            :disabled="disableSubscription"
          />
        </el-form-item>
      </div>
      <div class="form-group"
        v-if="storeForm.is_subscription"
      >
        <el-form-item
          label="Price"
          prop="subscription.price"
          :rules="[{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }]"
        >
          <el-input
            v-model="storeForm.subscription.price"
            clearable
            :disabled="disableSubscription"
          />
        </el-form-item>
        <el-form-item
          label="Price Yearly"
          prop="subscription.price_yearly"
          :rules="[{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }]"
          >
          <el-input
            v-model="storeForm.subscription.price_yearly"
            clearable
            :disabled="disableSubscription"
          />
        </el-form-item>
      </div>
      <div class="form-group"
        v-if="storeForm.is_subscription"
      >
        <el-form-item
          label="Image Recognition"
          prop="subscription.has_image_recognition"
        >
          <el-switch
            v-model="storeForm.subscription.has_image_recognition"
            inactive-color="#f56c6c"
            :disabled="disableSubscription"
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Goxip Online"
          prop="status"
        >
          <el-switch
            v-model="storeForm.status"
            inactive-color="#f56c6c"
          />
        </el-form-item>
        <el-form-item
          label="rewardSnap Online"
          prop="rs_status"
        >
          <el-switch
            v-model="storeForm.rs_status"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>


      <div v-if="!isEditMode">
        <h4 class="title">Create Member</h4>

        <div class="form-group">
          <el-form-item
            label="Member Name"
            prop="member_name"
          >
            <el-input
              v-model="storeForm.member_name"
              required
              placeholder="e.g. John Doe"
              style="width: 50%;"
            />
          </el-form-item>
          <el-form-item
            class="mt-3"
            label="Username"
            prop="username"
          >
            <el-input ref="memberUsername"
              v-model.trim="storeForm.username"
              clearable
            />
          </el-form-item>
          <el-form-item
            class="mt-3"
            label="Email"
            prop="email"
          >
            <el-input ref="memberEmail"
              v-model.trim="storeForm.email"
              clearable
            />
          </el-form-item>
          <el-form-item
            class="mt-3"
            label="Profile Image"
            prop="member_profile_image"
          >
            <el-upload
              v-loading="isUploading"
              v-model="member_profile_image"
              :file-list="memberProfileImageList"
              :limit="1"
              :disabled="isUploading"
              :http-request="handleUpload"
              :before-upload="handleBeforeUpload"
              :on-exceed="handleUploaderlimitExceed"
              :on-error="uploadfailed"
              :on-success="uploadSuccessful"
              list-type="picture"
              drag
              accept=".png, .jpg"
              action="noneed"
              :data="{field_name:'member_profile_image'}"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
            </el-upload>
          </el-form-item>

        </div>
      </div>
      <div v-else>
        <h4 class="title">Edit Member</h4>
        <div 
          v-if="storeForm.member.email"
          class="form-group"
        >
          <el-form-item
            class="mt-3"
            label="Email"
            prop="email"
          >
            <el-input
              v-model="storeForm.member.email"
              disabled
            />
          </el-form-item>
        </div>
        <div class="form-group">
          <el-form-item
            label="Profile Image"
            prop="member_profile_image"
          >
            <el-upload
              v-loading="isUploading"
              v-model="member_profile_image"
              :file-list="memberProfileImageList"
              :limit="1"
              :disabled="isUploading"
              :http-request="handleUpload"
              :before-upload="handleBeforeUpload"
              :on-exceed="handleUploaderlimitExceed"
              :on-error="uploadfailed"
              :on-success="uploadSuccessful"
              list-type="picture"
              drag
              accept=".png, .jpg"
              action="noneed"
              :data="{field_name:'member_profile_image'}"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
            </el-upload>
          </el-form-item>
        </div>

        <div class="d-flex" style="margin: 0 10px;">
          <el-button
            :disabled="isLoading || isSaving || !!storeForm.member.password_reset_link"
            size="mini"
            type="danger"
            icon="el-icon-edit"
            @click="handleResetMemberPassword"
          >
            Reset Member Password
          </el-button>
          <el-input
            v-if="storeForm.member.password_reset_link"
            v-model="storeForm.member.password_reset_link"
            readonly
          />
        </div>
      </div>

      <h4 class="title">Goxip Only</h4>

      <div class="form-group">
        <el-form-item
          label="Feed Affiliate"
          prop="gx_feed_affiliate"
        >
          <el-select
            v-model="storeForm.gx_feed_affiliate"
            filterable
            placeholder="Select"
            style="width: 100%;"
          >
            <el-option
              v-for="affiliate in affiliates"
              :key="affiliate"
              :label="affiliate"
              :value="affiliate"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Feed ID"
          prop="gx_feed_id"
        >
          <el-input
            v-model.trim="storeForm.gx_feed_id"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Deeplink Affiliate"
          prop="gx_deeplink_affiliate"
        >
          <el-select
            v-model="storeForm.gx_deeplink_affiliate"
            filterable
            placeholder="Select"
            style="width: 100%;"
          >
            <el-option
              v-for="affiliate in affiliates"
              :key="affiliate"
              :label="affiliate"
              :value="affiliate"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Deeplink ID"
          prop="gx_deeplink_advertiser_id"
        >
          <el-input
            v-model.trim="storeForm.gx_deeplink_advertiser_id"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Min Commission"
          prop="gx_min_commission_percentage"
        >
          <el-input
            v-model.number="storeForm.gx_min_commission_percentage"
            type="number"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="Max Commission"
          prop="gx_max_commission_percentage"
        >
          <el-input
            v-model.number="storeForm.gx_max_commission_percentage"
            type="number"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>

      <h4 class="title">rewardSnap Only</h4>

      <div class="form-group">
        <el-form-item
          label="Feed Affiliate"
          prop="rs_feed_affiliate"
        >
          <el-select
            v-model="storeForm.rs_feed_affiliate"
            filterable
            placeholder="Select"
            style="width: 100%;"
          >
            <el-option
              v-for="affiliate in affiliates"
              :key="affiliate"
              :label="affiliate"
              :value="affiliate"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Feed ID"
          prop="rs_feed_id"
        >
          <el-input
            v-model.trim="storeForm.rs_feed_id"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Deeplink Affiliate"
          prop="rs_deeplink_affiliate"
        >
          <el-select
            v-model="storeForm.rs_deeplink_affiliate"
            filterable
            placeholder="Select"
            style="width: 100%;"
          >
            <el-option
              v-for="affiliate in affiliates"
              :key="affiliate"
              :label="affiliate"
              :value="affiliate"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Deeplink ID"
          prop="rs_deeplink_advertiser_id"
        >
          <el-input
            v-model.trim="storeForm.rs_deeplink_advertiser_id"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Min Commission"
          prop="rs_min_commission_percentage"
        >
          <el-input
            v-model.number="storeForm.rs_min_commission_percentage"
            type="number"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="Max Commission"
          prop="rs_max_commission_percentage"
        >
          <el-input
            v-model.number="storeForm.rs_max_commission_percentage"
            type="number"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Remarks"
          prop="rs_remarks"
        >
          <el-input
            v-model="storeForm.rs_remarks"
            :autosize="{ minRows: 1, maxRows: 4}"
            type="textarea"
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="High Commission"
          prop="rs_is_high_commission"
        >
          <el-switch
            v-model="storeForm.rs_is_high_commission"
            inactive-color="#f56c6c"
          />
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Feed Type"
          prop="rs_feed_type"
        >
          <el-radio
            v-model="storeForm.rs_feed_type"
            label="gx"
          >
            Goxip
          </el-radio>
          <el-radio
            v-model="storeForm.rs_feed_type"
            label="rs"
          >
            rewardSnap
          </el-radio>
        </el-form-item>
      </div>

      <div class="form-group">
        <el-form-item
          label="Product Url Key"
          prop="rs_product_url_key"
        >
          <el-radio
            v-model="storeForm.rs_product_url_key"
            label="url"
          >url</el-radio>
          <el-radio
            v-model="storeForm.rs_product_url_key"
            label="rs_url"
          >rs_url</el-radio>
        </el-form-item>
      </div>


      <h4 class="title">{{ $t('store.countryDetail') }}</h4>
      <el-tabs
          v-model="activeCountryTab"
          type="card"
      >
        <el-tab-pane
            v-for="country in storeCountries"
            :key="country"
            :label="country"
            :name="country"
        >
          <store-country-form
              :form="storeForm.store_countries[country]"
          />
        </el-tab-pane>
        <el-tab-pane
            label="+"
        >
          <div class="px-3 pb-4">
            <p>{{ $t('store.selectNewCountryToAdd') }}</p>

            <el-button
                v-for="option in storeCountryOptions"
                :key="option"
                round
                @click="() => handleAddStoreCountry(option)"
            >
              {{ option }}
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>


      <div v-show="storeForm.feeds && storeForm.feed_countries">
        <h4 class="title">Feeds</h4>
        <el-table
            :data="storeForm.feed_countries"
            style="margin-bottom: 20px;"
        >
          <el-table-column
              align="left"
              prop="country"
              label="Country"
              width="100"
          >
            <template slot-scope="scope">
              <label>{{ scope.row.country.toUpperCase() }}</label>
            </template>
          </el-table-column>
          <el-table-column
              prop="Feed"
              align="left"
              label="Feed"
              min-width="150"
          >
            <template slot-scope="scope">
              <el-select
                  v-model="scope.row.feed"
                  filterable
                  placeholder="Select"
                  style="width: 100%;"
              >
                <el-option
                    v-for="feed in storeForm.feeds"
                    :key="feed.id"
                    :label="feed.label"
                    :value="feed.id"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <h4 class="title">Related ID(s)</h4>
      <el-table
        :data="storeForm.store_relations"
        style="margin-bottom: 20px;"
      >
        <el-table-column
          prop="affiliate"
          align="center"
          label="Affiliate"
          width="100"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.affiliate"
              filterable
              placeholder="Select"
              style="width: 100%;"
            >
              <el-option
                v-for="affiliate in affiliates"
                :key="affiliate"
                :label="affiliate"
                :value="affiliate"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="advertiser_id"
          label="Reference ID"
        >
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.advertiser_id"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="remarks"
            label="Remarks"
        >
          <template slot-scope="scope">
            <el-input
                v-model.trim="scope.row.remarks"
                clearable
            />
          </template>
        </el-table-column>
        <el-table-column
            :label="'Feed'"
            align="center"
            width="60"
        >
          <template slot-scope="scope">
            <el-checkbox
                v-model="scope.row.is_product_feed"
                class="pl-2"
            />
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="feed_path"
            label="Path"
        >
          <template slot-scope="scope">
            <el-input
                v-model.trim="scope.row.feed_path"
                :disabled="!scope.row.is_product_feed"
                clearable
            />
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="locale"
            label="Locale"
            width="100"
        >
          <template slot-scope="scope">
            <el-input
                v-model.trim="scope.row.locale"
                :disabled="!scope.row.is_product_feed"
                clearable
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="'Online'"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <el-checkbox
                v-model="scope.row.online"
                class="pl-2"
            />
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="60"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
                @click="handleRemoveStoreRelation(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="form-group">
        <el-button
            :disabled="isLoading || isSaving"
            class="add-editorial-item-button"
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="handleAddStoreRelation"
        >
          Add Related ID
        </el-button>
      </div>

    </el-form>
  </sticky-header-layout>
</template>

<script>
import FieldsetLocalizedInput from '@/components/form/FieldsetLocalizedInput.vue'
import StoreCountryForm from './StoreCountryForm.vue'

import { getRandomHash } from '../../utils/helper'
import { getStoreDetail, createStore, updateStore, checkSlugAvailability, resetStoreMemberPassword } from '../../api/stores'
import { checkEmailAvailability, checkUsernameAvailability } from '../../api/members'
import AffiliateService from '../../api/affiliates'
import { validateIsNonNegativeNumber } from '../../utils/element-ui-form-validators'

const countries = ['ca', 'us', 'uk', 'sg', 'hk', 'my', 'ph', 'in', 'th', 'au', 'tw']

export default {
  name: 'StoreDetail',
  components: {
    FieldsetLocalizedInput,
    StoreCountryForm,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      imageList: [],
      couponImageList: [],
      memberProfileImageList: [],
      storeForm: {
        name: '',
        displayname: '',
        slug: '',
        member_id: '',
        username: '', // this field gets modified by reshapeStoreToServerFormat
        member_name: '', // this field gets modified by reshapeStoreToServerFormat
        email: '',
        validation_text: '',
        bio: null,
        // image: '',
        genders: '',
        store_url: '',
        company_location: '',
        available_platform: [],
        available_countries: [],
        status: false,
        rs_status: false,
        is_subscription: false,
        is_generate_password: false,
        gx_feed_id: '',
        gx_feed_affiliate: '',
        gx_deeplink_advertiser_id: '',
        gx_deeplink_affiliate: '',
        rs_feed_id: '',
        rs_feed_affiliate: '',
        rs_deeplink_advertiser_id: '',
        rs_deeplink_affiliate: '',
        gx_min_commission_percentage: 0,
        gx_max_commission_percentage: 0,
        rs_min_commission_percentage: 0,
        rs_max_commission_percentage: 0,
        rs_remarks: '',
        rs_is_high_commission: false,
        rs_feed_type: 'gx',
        rs_product_url_key: 'rs_url',
        store_relations: [],
        tier: 4,
        store_countries: {},
        feeds: [],
        feed_countries: [],
        subscription: {
          name: '',
          description: '',
          price: '',
          price_yearly: '',
          has_image_recognition: false,
        },
        member: {
          email: '',
          profile_img: '',
          official_account: false,
          password_reset_link: '',
        },
        official_account: false,
      },
      storeFormRule: {
        name: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
        displayname: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
        slug: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
        available_platform: [{
          type: 'array',
          required: true,
          message: 'Please select at least one platform ',
          trigger: 'change',
        }],
        username: [
          { required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^[a-z0-9_]{4,}$/.exec(value)) {
                return callback()
              }
              return callback(this.$t('error.invalidUsername'))
            },
            trigger: 'blur',
          },
        ],
        member_name: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
        // member_profile_image: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
        gx_min_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
        gx_max_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
        rs_min_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
        rs_max_commission_percentage: [{ validator: validateIsNonNegativeNumber, trigger: 'blur' }],
        tier: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      },
      availablePlatforms: [
        { title: 'Goxip', label: 'goxip' },
        { title: 'rewardSnap', label: 'rs' },
      ],
      availableCountries: countries,
      affiliates: [],
      isLoadingAffiliates: false,
      isEdited: false,
      isLoading: false,
      isSaving: false,
      isUploading: false,
      // profile_image: [],
      member_profile_image: '',
      image: '',
      coupon_image: '',
      storeTiers: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
      ],
      activeCountryTab: null,
      disableSubscription: false,
    }
  },
  computed: {
    isEditMode() {
      return !!this.id
    },
    storeCountries() {
      return this.storeForm.store_countries ? Object.keys(this.storeForm.store_countries) : []
    },
    storeCountryOptions() {
      return countries.filter(country => !this.storeCountries.includes(country))
    },
  },
  watch: {
    storeForm: {
      handler() {
        this.isEdited = true
      },
      deep: true,
    },
    'storeForm.name': function _(value) {
      if (this.isEditMode) return
      this.storeForm.displayname = value
      this.storeForm.member_name = value
      this.storeForm.slug = value.replace(/\s/g, '-').toLowerCase()
      this.storeForm.username = value.replace(/\s/g, '_').toLowerCase()
    },
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      // this.goToTrendingFeeds()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: this.$t('button.ok'),
      })
    },
    storeCountries(list, prevList) {
      if (list.length > 0) {
        if (prevList.length > 0) {
          [this.activeCountryTab] = list.slice(-1)
        } else {
          [this.activeCountryTab] = list
        }
      }
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.getStore(this.id)
    } else {
      // Preselect all platforms when creating store
      this.storeForm.available_platform = this.availablePlatforms.reduce((acc, cur) => [...acc, cur.label], [])

      // Preselect all countries when creating store
      this.storeForm.available_countries = countries
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await AffiliateService.getAffiliateList()
      const affiliates = response.data.reduce((prev, cur) => [...prev, cur.type], [])
      /* eslint-disable-next-line */
      next(vm => { vm._data.affiliates = affiliates })
    } catch (error) {
      next(new Error('Could not get affilaite list'))
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      return next(false)
    }

    if (!this.isEdited) {
      return next()
    }

    try {
      await this.$confirm(this.$t('message.leaveWithUnsavedChanges'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.leave'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      })
      return next()
    } catch (error) {
      return next(false)
    }
  },
  methods: {
    async handleUpload(uploadAction) {
      // this.storeForm.member_profile_image = uploadAction.file
      this.isUploading = true

      // const payload = {
      //   file: uploadAction.file,
      // }

      try {
        // const { data } = await uploadTrendingBatch(payload)
        // this.storeForm.member_profile_image = data
        this[uploadAction.data.field_name] = uploadAction.file
        // eval(`this.${uploadAction.data.field_name} = uploadAction.file`)
        // this.member_profile_image = uploadAction.file
        uploadAction.onSuccess()
      } catch (error) {
        uploadAction.onError(error)
      }
    },
    uploadSuccessful() {
      // this.$refs.uploader.clearFiles()
      this.isUploading = false
    },
    uploadfailed(error) {
      console.log(error)
      this.isUploading = false
      this.$alert(
        'Please try again later.',
        'Upload Failed', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    handleBeforeUpload(file) {
      if (!file.name.includes('.png') && !file.name.includes('.jpg') && !file.name.includes('.jpeg')) {
        this.$alert(
          'Please double check you are uploading a .png, .jpg, or .jpeg file',
          'Incorrect File Type', {
            type: 'error',
            confirmButtonText: 'OK',
          },
        )
        return false
      }

      return true
    },
    handleUploaderlimitExceed() {
      this.$alert(
        'Sorry, please upload one file at a time!',
        'Too Many Files', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    async checkStoreSlugAvailability() {
      await checkSlugAvailability(this.storeForm.slug).catch((error) => {
        switch (error) {
          case 'STORE_SLUG_EXIST':
            error = this.$t('error.storeSlugExist')
            break;
        }
        throw new Error(error)
      })
    },
    async checkUsernameEmailAvailability() {
      await checkUsernameAvailability(this.storeForm.username).then(() => {
        if (this.storeForm.email) {
          return checkEmailAvailability(this.storeForm.email)
        } else {
          return new Promise((resolve) => {resolve()})
        }
      }).then(() => {
        
      }).catch((error) => {
        switch (error) {
          case 'MEMBER_EMAIL_EXIST':
            error = this.$t('error.memberEmailExist')
            this.$refs.memberEmail.focus()
            break;
          case 'MEMBER_USERNAME_EXIST':
            error = this.$t('error.memberUsernameExist')
            console.log(error)
            this.$refs.memberUsername.focus()
            break;
        }
        throw new Error(error)
      })
    },
    async createNewStore(storeForm) {
      this.isSaving = true

      const autoFilledStoreForm = this.autoFillEmptyFeedIdAndAffiliateIfNeeded({ ...storeForm })
      const store = this.reshapeStoreToServerFormat(autoFilledStoreForm)
      console.log('create', store)
      try {
        await this.checkStoreSlugAvailability()
        await this.checkUsernameEmailAvailability()
        const result = await createStore(store, this.member_profile_image, this.image, this.coupon_image)
        const email = result.data.member_result.data.email
        const password = result.data.new_generate_password
        this.$alert(`<p><b>Email</b>: ${email}</p><p><b>Password</b>: ${password}</p>`, 'Detail', {
          type: 'success',
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
        })
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async editStore(storeForm) {
      this.isSaving = true
      const store = this.reshapeStoreToServerFormat(storeForm)
      try {
        const result = await updateStore(store, this.id, this.member_profile_image, this.image, this.coupon_image)
        const password = result.data.new_generate_password
        if (password) {
          this.$alert(`password: ${password}`, 'Detail', {
            type: 'success',
            confirmButtonText: 'OK',
          })
        }
        // const password = result.data.new_generate_password
        // this.$alert('Detail', `password ${password}`, {
        // type: 'success',
        // confirmButtonText: 'OK',
        // })
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async getStore(storeId) {
      this.isLoading = true
      try {
        const { data: store } = await getStoreDetail(storeId)
        this.storeForm = this.reshapeStore(store)
        if (this.storeForm.member.profile_img) {
          this.memberProfileImageList.push({
            name: '',
            url: this.storeForm.member.profile_img,
          })
        } 
        if (this.storeForm.image) {
          this.imageList.push({
            name: '',
            url: this.storeForm.image,
          })
        } 
        if (this.storeForm.coupon_image) {
          this.couponImageList.push({
            name: '',
            url: this.storeForm.coupon_image,
          })
        } 
        // this.disableSubscription = true
        if (this.storeForm.is_subscription === 1) {
          this.storeForm.is_subscription = true
        } else {
          this.storeForm.is_subscription = false
          // this.storeForm.subscription = {
          //   name: '',
          //   description: '',
          //   price: '',
          //   price_yearly: '',
          //   has_image_recognition: false,
          // }
          this.disableSubscription = false
        }
        if (this.storeForm.official_account === 1 ) {
          this.storeForm.official_account = true
        } else {
          this.storeForm.official_account = false
        }
        this.$nextTick(() => {
          this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        console.log({ error });
        this.isLoading = false
      }
    },
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      this.goToStoreList()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    goToStoreList() {
      this.$router.push({ path: '/store/list' })
    },
    reshapeStore(store) {
      // Add id to each relation so we can perform deletion
      store.store_relations = store.store_relations.map(relation => ({
        ...relation,
        id: getRandomHash(),
      }))
      for (let el of store.store_relations) {
        el.online = !!el.online
        el.is_product_feed = !!el.is_product_feed
      }

      // Convert all to goxip and rs.
      if (store.available_platform === 'all') {
        store.available_platform = this.availablePlatforms.reduce((acc, cur) => [...acc, cur.label], [])
      } else {
        store.available_platform = [store.available_platform]
      }

      // Convert 0 and 1 to true and false
      store.rs_status = !!store.rs_status
      store.status = !!store.status
      store.rs_is_high_commission = !!store.rs_is_high_commission

      store.gx_min_commission_percentage = !Number.isNaN(+store.gx_min_commission_percentage)
        ? +store.gx_min_commission_percentage
        : 0
      store.gx_max_commission_percentage = !Number.isNaN(+store.gx_max_commission_percentage)
        ? +store.gx_max_commission_percentage
        : 0

      store.rs_min_commission_percentage = !Number.isNaN(+store.rs_min_commission_percentage)
        ? +store.rs_min_commission_percentage
        : 0
      store.rs_max_commission_percentage = !Number.isNaN(+store.rs_max_commission_percentage)
        ? +store.rs_max_commission_percentage
        : 0

      // Convert selected country keys to array
      const availableCountries = []
      Object.keys(store).forEach((key) => {
        if (this.availableCountries.indexOf(key) >= 0) {
          if (store[key]) {
            availableCountries.push(key)
          }
          delete store[key]
        }
      })
      store.available_countries = availableCountries

      if (!store.store_countries || Array.isArray(store.store_countries)) {
        store.store_countries = {}
      }
      Object.keys(store.store_countries).forEach((key) => {
        store.store_countries[key].is_free_shipping = Boolean(store.store_countries[key].is_free_shipping)
        store.store_countries[key].is_free_return = Boolean(store.store_countries[key].is_free_return)
      })

      // Convert feed countries to array
      if (store.feed_countries) {
        store.feed_countries = Object.keys(store.feed_countries).map(key => ({
          "country": key, "feed": store.feed_countries[key]
        }))
      }

      if (Array.isArray(store.feeds)) {
        store.feeds.push({ id: 0, label: "N/A" })
      }

      if (!store.subscription) {
        store.subscription = {
            name: '',
            description: '',
            price: '',
            price_yearly: '',
            has_image_recognition: false,
          }
      }

      if (!store.member) {
        store.member = {
          email: '',
          profile_img: '',
          official_account: false,
          password_reset_link: '',
        }
      }
      return store
    },
    reshapeStoreToServerFormat(store) {
      let copiedStore = { ...store }

      // Convert goxip and rs to all. if the array is empty, set it to null.
      if (copiedStore.available_platform.length > 0) {
        if (copiedStore.available_platform.length === this.availablePlatforms.length) {
          copiedStore.available_platform = 'all'
        } else {
          [copiedStore.available_platform] = copiedStore.available_platform
        }
      } else {
        copiedStore.available_platform = ''
      }

      // add member
      const member = { name: copiedStore.member_name, username: copiedStore.username, email: copiedStore.email }
      delete copiedStore.member_name
      delete copiedStore.username
      delete copiedStore.email
      copiedStore = { ...copiedStore, member }

      // Convert 0 and 1 to true and false
      copiedStore.rs_status = +!!copiedStore.rs_status
      copiedStore.status = +!!copiedStore.status
      copiedStore.rs_is_high_commission = +!!copiedStore.rs_is_high_commission

      // Convert country array to key value pairs
      const selectedAvailableCountries = {}
      this.availableCountries.forEach((country) => {
        selectedAvailableCountries[country] = 0
      })
      copiedStore.available_countries.forEach((country) => {
        selectedAvailableCountries[country] = 1
      })
      delete copiedStore.available_countries
      copiedStore = { ...copiedStore, ...selectedAvailableCountries }

      this.storeCountries.forEach((country) => {
        copiedStore.store_countries[country].is_free_return = Number(copiedStore.store_countries[country].is_free_return)
        copiedStore.store_countries[country].is_free_shipping = Number(copiedStore.store_countries[country].is_free_shipping)
      })

      for (let el of copiedStore.store_relations) {
        if (el.online === true) {
          el.online = 1
        }
        if (el.online === false) {
          el.online = 0
        }
        if (el.is_product_feed === true) {
          el.is_product_feed = 1
        }
        if (el.is_product_feed === false) {
          el.is_product_feed = 0
        }
      }

      if (Array.isArray(copiedStore.feed_countries)) {
        copiedStore.feed_countries = copiedStore.feed_countries.reduce((obj, row) => {
          obj[row.country] = row.feed;
          return obj
        }, {})
      }
      return copiedStore
    },
    autoFillEmptyFeedIdAndAffiliateIfNeeded(storeForm) {
      if (storeForm.gx_feed_affiliate) {
        if (!storeForm.gx_deeplink_affiliate) storeForm.gx_deeplink_affiliate = storeForm.gx_feed_affiliate
        if (!storeForm.rs_feed_affiliate) storeForm.rs_feed_affiliate = storeForm.gx_feed_affiliate
        if (!storeForm.rs_deeplink_affiliate) storeForm.rs_deeplink_affiliate = storeForm.gx_feed_affiliate
      }

      if (storeForm.gx_feed_id) {
        if (!storeForm.gx_deeplink_advertiser_id) storeForm.gx_deeplink_advertiser_id = storeForm.gx_feed_id
        if (!storeForm.rs_deeplink_advertiser_id) storeForm.rs_deeplink_advertiser_id = storeForm.gx_feed_id
        if (!storeForm.rs_feed_id) storeForm.rs_feed_id = storeForm.gx_feed_id
      }

      return storeForm
    },
    getStoreRelation() {
      return {
        id: getRandomHash(),
        online: true,
        affiliate: '',
        advertiser_id: '',
      }
    },
    handleCancel() {
      this.goToStoreList()
    },
    async handleSave() {
      try {
        await this.$refs.form.validate()

        if (this.isEditMode) {
          this.editStore(this.storeForm, this.id)
        } else {
          this.createNewStore(this.storeForm)
        }
      } catch (error) {
        this.$alert('Please fill in all the required information.', 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
    handleAddStoreRelation() {
      this.storeForm.store_relations.push(this.getStoreRelation())
    },
    handleRemoveStoreRelation(row) {
      const idToRemove = row.id
      const index = this.storeForm.store_relations.findIndex(relation => relation.id === idToRemove)
      this.storeForm.store_relations.splice(index, 1)
    },
    // handleDeleteProfileImage() {
    //   this.member_profile_image = ''
    // },
    handleAddStoreCountry(country) {
      this.$set(this.storeForm.store_countries, country, {
        shipping_info: {
          value_en: null,
          value_zh_hk: null,
          value_zh_cn: null,
          value_zh_tw: null,
          value_th_th: null,
        },
        return_policy: {
          value_en: null,
          value_zh_hk: null,
          value_zh_cn: null,
          value_zh_tw: null,
          value_th_th: null,
        },
        is_free_shipping: 0,
        free_shipping_info: {
          value_en: null,
          value_zh_hk: null,
          value_zh_cn: null,
          value_zh_tw: null,
          value_th_th: null,
        },
        is_free_return: 0,
        free_return_info: {
          value_en: null,
          value_zh_hk: null,
          value_zh_cn: null,
          value_zh_tw: null,
          value_th_th: null,
        },
      })
      this.activeCountryTab = country
    },
    async handleResetMemberPassword(){
      this.$confirm(this.$t('message.confirmToReset'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.ok'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        this.resetMemberPassword()
      })
    },
    async resetMemberPassword(){
      this.isLoading = true
      try {
        const result = await resetStoreMemberPassword(this.id)
        const { data: store } = await getStoreDetail(this.id)

        this.storeForm.member.password_reset_link = store.member.password_reset_link
        
        this.$nextTick(() => {
          this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        console.log({ error });
        this.isLoading = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss" scoped>
::v-deep {
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-upload-list__item-thumbnail {
    width: auto;
    height: 100%;
  }
}

</style>
